import { Logo } from "./Logo";
import { ShoppingBag } from "lucide-react";

const LINKS = [
  { label: "What's Inside", href: "#inside" },
  { label: "How It Works", href: "#how" },
  { label: "Compare", href: "#compare" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
];

export function Navbar({ onBuy }) {
  return (
    <header data-testid="main-navbar" className="sticky top-0 z-40 border-b border-white/10 bg-[#0e131f]/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
        <a href="#top" data-testid="nav-logo-link"><Logo /></a>
        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-slate-400 transition-colors hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button
            data-testid="nav-order-now-button"
            onClick={onBuy}
            className="group flex items-center gap-2 rounded-full bg-cyan-400 px-5 py-2.5 text-sm font-bold text-[#07090e] transition-transform hover:scale-105 active:scale-95"
          >
            <ShoppingBag className="h-4 w-4 transition-transform group-hover:-rotate-12" />
            Order Now
          </button>
        </div>
      </div>
    </header>
  );
}
